module.exports = __webpack_public_path__ + "img/bg5.dbb6f537.png";